import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase, apiGeneratorDelete } from "../../../Utils/saga"
import BusinessAccountsActions from "../../BusinessAccountsPage/reducer"
import Creators, { RequestsEnrollmentsTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getRequestsEnrollmentsFilterOptionsActions: {
    request: Creators.getRequestsEnrollmentsFilterOptionsRequest,
    success: Creators.getRequestsEnrollmentsFilterOptionsSuccess,
    errors: Creators.getRequestsEnrollmentsFilterOptionsFailure
  },
  getRequestsEnrollmentsActions: {
    request: Creators.getRequestsEnrollmentsRequest,
    success: Creators.getRequestsEnrollmentsSuccess,
    errors: Creators.requestsEnrollmentsFailure
  },
  updateRequestsEnrollmentActions: {
    request: Creators.updateRequestsEnrollmentRequest,
    success: Creators.updateRequestsEnrollmentSuccess,
    errors: Creators.requestsEnrollmentsFailure,
    extraAction: [BusinessAccountsActions.getStatisticsAdminRequest]
  },
  deleteRequestsEnrollmentActions: {
    request: Creators.deleteRequestsEnrollmentRequest,
    success: Creators.deleteRequestsEnrollmentSuccess,
    errors: Creators.requestsEnrollmentsFailure,
    extraAction: [BusinessAccountsActions.getStatisticsAdminRequest]
  },
  bulkUpdateRequestsEnrollmentActions: {
    request: Creators.bulkUpdateRequestsEnrollmentRequest,
    success: Creators.bulkUpdateRequestsEnrollmentSuccess,
    errors: Creators.bulkUpdateRequestsEnrollmentFailure,
    extraAction: [BusinessAccountsActions.getStatisticsAdminRequest],
    withoutErrorNotification: true,
  },
  getRequestsEnrollmentsExportActions: {
    request: Creators.getRequestsEnrollmentsExportRequest,
    success: Creators.getRequestsEnrollmentsExportSuccess,
    errors: Creators.getRequestsEnrollmentsExportFailure
    //downloadFile: true,
  }
}

const eventsOptions = {
  [constants.GET_REQUESTS_ENROLLMENTS_FILTER_OPTIONS_REQUEST]: {
    api: services.getRequestsEnrollmentsFilterOptions,
    actions: actions.getRequestsEnrollmentsFilterOptionsActions
  },
  [constants.GET_REQUESTS_ENROLLMENTS_REQUEST]: {
    api: services.getEnrollmentsRequests,
    actions: actions.getRequestsEnrollmentsActions
  },
  [constants.UPDATE_REQUESTS_ENROLLMENT_REQUEST]: {
    api: services.updateEnrollmentRequests,
    actions: actions.updateRequestsEnrollmentActions
  },
  [constants.DELETE_REQUESTS_ENROLLMENT_REQUEST]: {
    api: services.deleteEnrollmentRequests,
    actions: actions.deleteRequestsEnrollmentActions
  },
  [constants.BULK_UPDATE_REQUESTS_ENROLLMENT_REQUEST]: {
    api: services.bulkUpdateEnrollmentRequestStatus,
    actions: actions.bulkUpdateRequestsEnrollmentActions,
  },
  [constants.GET_REQUESTS_ENROLLMENTS_EXPORT_REQUEST]: {
    api: services.getRequestsEnrollmentsExport,
    actions: actions.getRequestsEnrollmentsExportActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_REQUESTS_ENROLLMENTS_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(
      action,
      eventsOptions[constants.GET_REQUESTS_ENROLLMENTS_FILTER_OPTIONS_REQUEST]
    )
  )
  yield takeLatest(constants.GET_REQUESTS_ENROLLMENTS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUESTS_ENROLLMENTS_REQUEST])
  )
  yield takeLatest(constants.UPDATE_REQUESTS_ENROLLMENT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_REQUESTS_ENROLLMENT_REQUEST])
  )
  yield takeLatest(constants.DELETE_REQUESTS_ENROLLMENT_REQUEST, (action) =>
    apiGeneratorDelete(action, eventsOptions[constants.DELETE_REQUESTS_ENROLLMENT_REQUEST])
  )
  yield takeLatest(constants.GET_REQUESTS_ENROLLMENTS_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUESTS_ENROLLMENTS_EXPORT_REQUEST])
  )
  yield takeLatest(constants.BULK_UPDATE_REQUESTS_ENROLLMENT_REQUEST, (action)=> apiGeneratorBase(action, eventsOptions[constants.BULK_UPDATE_REQUESTS_ENROLLMENT_REQUEST]));
}
